module.exports = __webpack_public_path__ + "static/media/heart-purple.d020e352.svg";